/**
 * A simplified utility to estimate Hindu Vikram Samvat details.
 * Accurate Panchang calculation requires complex astronomical algorithms.
 * This version provides a close approximation for display purposes.
 */

const HINDI_MONTHS = [
  "Chaitra", "Vaisakha", "Jyaistha", "Ashadha", 
  "Shravana", "Bhadrapada", "Ashvina", "Kartika", 
  "Agrahayana", "Pausa", "Magha", "Phalguna"
];

const TITHIS = [
  "Pratipada", "Dwitiya", "Tritiya", "Chaturthi", "Panchami", 
  "Shashti", "Saptami", "Ashtami", "Navami", "Dashami", 
  "Ekadashi", "Dwadashi", "Trayodashi", "Chaturdashi", "Purnima",
  "Pratipada", "Dwitiya", "Tritiya", "Chaturthi", "Panchami", 
  "Shashti", "Saptami", "Ashtami", "Navami", "Dashami", 
  "Ekadashi", "Dwadashi", "Trayodashi", "Chaturdashi", "Amavasya"
];

/**
 * Approximate the Vikram Samvat date.
 * Year: Gregorian + 57 (approx)
 * Month/Tithi: Estimated based on lunar cycle reference.
 */
export function getVikramSamvat(date = new Date()) {
  // 1. Vikram Samvat Year
  // The Hindu New Year (Chaitra Shukla Pratipada) usually falls in March/April.
  // Before that, the VS year is Greg + 56, after that it's Greg + 57.
  const year = date.getFullYear();
  const month = date.getMonth(); // 0-indexed
  const day = date.getDate();
  
  let vsYear = year + 57;
  // Approximation: If before April 1st, use 56 (New year usually starts around late March/early April)
  if (month < 3) vsYear = year + 56;

  // 2. Tithi and Month (Approximate calculation)
  // Base date: March 25, 2020 was Chaitra Shukla Pratipada (Approx start of VS 2077)
  const baseDate = new Date(2020, 2, 25);
  const diffDays = Math.floor((date - baseDate) / (1000 * 60 * 60 * 24));
  
  // Average Lunar Month is ~29.53 days
  const lunarCycle = 29.530588;
  
  // Days since base in lunar terms
  const daysInCycle = (diffDays % lunarCycle + lunarCycle) % lunarCycle;
  const tithiIndex = Math.floor(daysInCycle);
  const tithiName = TITHIS[tithiIndex] || TITHIS[0];
  const paksha = tithiIndex < 15 ? "Shukla" : "Krishna";

  // Month calculation
  const totalLunarMonths = Math.floor(diffDays / lunarCycle);
  const vsMonthIndex = (totalLunarMonths % 12 + 12) % 12;
  const vsMonth = HINDI_MONTHS[vsMonthIndex];

  return {
    tithi: tithiName,
    paksha: paksha,
    month: vsMonth,
    year: vsYear,
    full: `${tithiName} (${paksha}), ${vsMonth} ${vsYear} Vikram Samvat`
  };
}
